<template>
  <div class="dep-structure">
    <info-block :title="$t('labels.structure')"
                marker-color="#8099F5"
                >
      <div class="dep-structure__tree">
        <dep-tree :depList="depList" :shortMode="true"></dep-tree>
      </div>
    </info-block>
  </div>
</template>
<script>
  import depTree from 'src/components/Orgs/OrgsTree/OrgsTree.vue'
  // import getDepartmentList from 'src/services/departmentList'
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'

  export default {
    props: ['orgId'],
    components: {
      depTree,
      infoBlock
    },
    data () {
      return {
        depList: []
      }
    },
    methods: {
      async getDepList () {
        let list = await this.$store.dispatch('orgs/byParent', this.orgId)
        let tree = this.$store.getters['orgs/getRawTree'](list)
        this.depList = tree;
      }
    },
    async mounted () {
      await this.getDepList()

      this.$bus.$on('pathChanged', this.getDepList)
    },
    beforeDestroy () {
      this.$bus.$off('pathChanged', this.getDepList)
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.dep-structure {
  &__tree {
    overflow: auto;
    margin: -15px -30px 0 -30px;

    @media (max-width: $screen-sm){
     margin: -15px -15px 0 -15px;
    }
  }
  .dep-tree {
    min-width: 400px;
  }
}
</style>